import Marquee from 'react-fast-marquee';
import { motion } from 'framer-motion';

// Placeholder client logos (these would be replaced with actual logos)
const clients = [
  { name: 'Liberty Mutual', color: '#1E3A8A' },
  { name: 'Nationwide', color: '#0369A1' },
  { name: 'Travelers', color: '#DC2626' },
  { name: 'Progressive', color: '#0284C7' },
  { name: 'Hartford', color: '#7C3AED' },
  { name: 'Allstate', color: '#0891B2' },
  { name: 'GEICO', color: '#059669' },
  { name: 'MetLife', color: '#1D4ED8' },
];

const ClientLogo = ({ name, color }) => (
  <div 
    className="flex items-center justify-center w-40 h-16 mx-8 bg-white rounded-lg border border-slate-100 shadow-sm hover:shadow-md transition-shadow duration-300"
    data-testid={`client-logo-${name.toLowerCase().replace(/\s+/g, '-')}`}
  >
    <div 
      className="text-sm font-bold tracking-wide"
      style={{ color }}
    >
      {name}
    </div>
  </div>
);

export const ClientLogos = ({ className = '' }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className={className}
    >
      <p className="text-center text-sm font-medium text-slate-500 mb-8 uppercase tracking-wider">
        Trusted by Leading Insurance Companies
      </p>
      <Marquee
        gradient={true}
        gradientColor="#FFFFFF"
        gradientWidth={100}
        speed={40}
        pauseOnHover={true}
        className="overflow-hidden"
      >
        {clients.map((client, index) => (
          <ClientLogo key={index} {...client} />
        ))}
      </Marquee>
    </motion.div>
  );
};

export const ClientLogosStatic = ({ className = '' }) => {
  return (
    <div className={`grid grid-cols-2 md:grid-cols-4 gap-6 ${className}`}>
      {clients.slice(0, 8).map((client, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: index * 0.05 }}
        >
          <ClientLogo {...client} />
        </motion.div>
      ))}
    </div>
  );
};
